import { useTranslation } from 'next-i18next'
// Dependencies.
import styled, { css } from 'styled-components'
import { useContext, useEffect } from 'react'
import { NextPage } from 'next'

import { Section } from '../Section'
import { EventsContext } from '../../context'
import { NookEvent } from '../../types'
import { H1 } from '../H1'
import { EventItem } from '../EventItem'
import {
  icons,
  colors,
  forScreensGreaterThanMobileWidth,
  screens,
  show,
} from '../../utils'
import { P } from '../P'
import { Hyperlink } from '../Hyperlink'
import { EventItemPlaceholder } from '../EventItemPlaceholder'

// 5fr 5fr;

// Defs
interface Props {
  eventsToShow: NookEvent[]
  firstEventIndex: number
  numberOfEventToShow?: number
  showAddNewEvent?: boolean
  page: string
  className?: string
  showPlaceHolderWhenEmpty?: boolean
  placeholder?: string
  showInvitedBanners?: boolean
  numberOfMobileColumns?: number
  showFreeSpacesBanner?: boolean
}

interface StyleProps {
  numberOfMobileColumns?: number
}

// Styles
const eventListStyles = css`
  width: 100%;

  .content {
    display: grid;
    grid-gap: 10px;
    grid-auto-flow: row dense;
    grid-template-columns: 2.5fr 2.5fr 2.5fr 2.5fr;
    grid-row-gap: 60px;

    /* Change the number of rows on mobile */
    @media (max-width: ${screens.mobile}) {
      grid-row-gap: 35px;
      grid-template-columns: ${(props) => {
        const _showInvitedBanners = props['numberOfMobileColumns'] || 1
        let rows = ''
        for (let row = 0; row < _showInvitedBanners; row++) {
          rows = `${rows} ${(10 / 10) * _showInvitedBanners}fr `
        }
        return rows
      }};
    }
  }

  /* TODO: Remove  Legacy Styles that are no longer in use */
  .addNewEvent {
    width: 237px;
    max-width: 100%;
    height: 304px;
    cursor: pointer;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    & > .buttonContainer {
      width: 60px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;

      & > .addButton {
        width: 24px;
        height: 24px;
      }
    }

    & > .addNewEventText {
      color: ${colors.purple};
    }
  }
`

const Container = styled(Section)<StyleProps>`
  ${eventListStyles}
`

// Information Fields.
const EventItemList: NextPage<Props> = (props) => {
  const { t } = useTranslation('common')

  //Prop
  const {
    className,
    eventsToShow,
    firstEventIndex,
    numberOfEventToShow,
    showAddNewEvent,
    page,
    showPlaceHolderWhenEmpty,
    placeholder,
    showInvitedBanners,
    numberOfMobileColumns,
    showFreeSpacesBanner,
  } = props

  const addNewEventOnclick = (event: React.MouseEvent<HTMLDivElement>) => {}

  let eventList = []
  if (numberOfEventToShow) {
    eventList = eventsToShow.slice(
      firstEventIndex,
      firstEventIndex + numberOfEventToShow,
    )
  } else {
    eventList = eventsToShow.slice(firstEventIndex)
  }

  // ..
  return (
    <Container
      className={`EventItemList ${className || ''}`}
      numberOfMobileColumns={numberOfMobileColumns}>
      {/* List of Events */}
      {eventList.map((event, index) => {
        return (
          <EventItem
            key={index}
            event={event}
            page={page}
            showInvitedBanner={showInvitedBanners || false}
            showFreeSpaceBanner={showFreeSpacesBanner || false}
          />
        )
      })}

      {/* Show placeholder card when empty  */}
      {show(showPlaceHolderWhenEmpty === true && eventList?.length < 1) && (
        <>
          <EventItemPlaceholder placeholder={placeholder || ''} />
        </>
      )}

      {/* show the add new option at the bottom - this may be a legacy option in future  */}
      {/* TODO: Remove  Legacy Option that are no longer in use */}
      {show(showAddNewEvent && showAddNewEvent === true) && (
        <>
          <Hyperlink className="addNewEvent" href="/events/create">
            <div className="buttonContainer">
              <img className="addButton" src={icons.add}></img>
            </div>
            <P className="callout addNewEventText">
              {t(`Add new event`, `Add new event`)}
            </P>
          </Hyperlink>
        </>
      )}
    </Container>
  )
}

// Export.
export default EventItemList
